






























import VFileInputWithValidation from '@/components/VFileInputWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import VTextAreaWithValidation from '@/components/VTextAreaWithValidation.vue';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { IBlacklistAddressCreate } from '@/interfaces';
import { dispatchCreateBlacklistAddress } from '@/store/main/accessors';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    VFileInputWithValidation,
    VTextFieldWithValidation,
    VSelectWithValidation,
    VTextAreaWithValidation,
  },
})
export default class CreateBlacklistAddress extends Vue {
  public valid = false;
  public address = '';
  public commentary = '';
  public selfban = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async reset() {
    this.address = '';
    this.commentary = '';
    this.selfban = false;
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const address: IBlacklistAddressCreate = {
        address: this.address,
        commentary: this.commentary,
        selfban: this.selfban,
      };
      const result = await dispatchCreateBlacklistAddress(this.$store, {
        id: Number(this.$router.currentRoute.params.id),
        payload: address,
      });
      if (result) {
        this.$router.push({ name: 'main-blacklist-addresses-all' });
      }
    }
  }
}
